import { render, staticRenderFns } from "./SensorsContainer.vue?vue&type=template&id=23740d52&scoped=true&"
import script from "./SensorsContainer.vue?vue&type=script&lang=js&"
export * from "./SensorsContainer.vue?vue&type=script&lang=js&"
import style0 from "./SensorsContainer.vue?vue&type=style&index=0&id=23740d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23740d52",
  null
  
)

export default component.exports